import t from "./index636.js";
import { withInstall as e } from "./index604.js";
const l = e(t);
export {
  l as ElDatePickerPanel,
  l as default
};
